// extracted by mini-css-extract-plugin
module.exports = {"subcontent":"Project_subcontent__2Ddvy","title":"Project_title__LOTnp","project":"Project_project__31V_J"};